export function throttle(func: Function, delay: number) {

    let isDelayed = false;
    let isNextCall = false;
    let savedArgs: any[] | undefined;

    return function throttle_inner(this: any, ...args: any[]) {
        if (isDelayed) {
            savedArgs = args;
            isNextCall = true;
        } else {
            isDelayed = true;
            isNextCall = false;

            func.apply(this, args);

            setTimeout(() => {
                isDelayed = false;
                if (isNextCall && savedArgs) {
                    throttle_inner.apply(this, savedArgs);
                    savedArgs = undefined;
                }
            }, delay);
        }
    }
}
